export default __webpack_public_path__ + "static/media/wheel-icon.01ee9b68.svg";